module.exports = __webpack_public_path__ + "img/5-3.79f7639d.svg";